import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactNotification from "react-notifications-component";
import merge from 'lodash/merge';
import isWindow from 'components/common/helpers/isWindow';

// docs:
// https://github.com/teodosii/react-notifications-component

class Notifications extends Component {

  constructor(props) {
    super(props);
    if (isWindow) {
      this.notificationDOMRef = React.createRef();
    }
    this.state = { hasMounted: false };
  }

  componentDidMount() {
    this.setState({ hasMounted: true });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.notification.id !== this.props.notification.id) {
      this.createNotification(this.props.notification.params);
    }
  }

  createNotification = (storeParams) => {
    const { locale } = this.props;
    var defaultParams = {
      // title: TransHelper.translate(locale, 'content.notifications.default.success'),
      title: null,
      message: "Data saved!",
      type: "danger",
      insert: "bottom",
      container: "top-right",
      animationIn: ["animated", "fadeIn"],
      animationOut: ["animated", "fadeOut"],
      dismiss: { duration: 3000 },
      dismissable: { click: true },
    }
    var params = merge({}, defaultParams, storeParams);
    this.notificationDOMRef.current.addNotification(params);
  }

  render() {
    if (!this.state.hasMounted) {
      return null;
    }

    return (
      <ReactNotification ref={this.notificationDOMRef} breakpoint="640" />
    )
  }
}

const mapStateToProps = (state) => {
  return {
    locale: state.app.locale,
    notification: state.service.notification
  }
}

export default connect(mapStateToProps)(Notifications);
